import React from 'react';
import { Section } from './ui/Section';
import { trackAddToCart } from '../utils/metaPixel';
import { Button } from './ui/Button';
const PURCHASE_URL = 'https://tucambiohoy.online/cart/42988674941041:1';
export function ValueStackSection() {
  const handleScrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Section background="cream" data-id="element-406">
      <div className="text-center mb-8" data-id="element-407">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-2" data-id="element-408">
          No te llevas solo un libro...
        </h2>
        <p className="text-[#2d3748]" data-id="element-409">
          Te llevas el <strong data-id="element-410">SISTEMA COMPLETO DE TRANSFORMACIÓN</strong>
        </p>
      </div>

      <div className="space-y-5 mb-8" data-id="element-411">
        {/* Main product */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" data-id="element-412">
          <div className="bg-[#1e3a5f] px-4 py-2" data-id="element-413">
            <span className="text-white text-xs font-bold uppercase tracking-wider" data-id="element-414">
              📘 Guía Principal
            </span>
          </div>
          <div className="p-5 flex gap-4 items-start" data-id="element-415">
            <img src="https://cdn.magicpatterns.com/uploads/kmpyfjAbrX2NFA18gFjysA/Nueva_Portada_de_libro_Pantallas_bajo_Control.png" alt="Guía Maestra Pantallas Bajo Control" className="w-36 md:w-44 rounded-lg shadow-md shrink-0" data-id="element-416" />
            <div className="flex-1" data-id="element-417">
              <h3 className="font-bold text-[#1e3a5f] text-base mb-1" data-id="element-418">
                Guía Maestra "Pantallas Bajo Control"
              </h3>
              <p className="text-[#2d3748] text-sm mb-2 leading-relaxed" data-id="element-419">
                El mapa de 30 días para desintoxicar el cerebro digital de tus
                hijos.
              </p>
              <div className="flex items-center gap-2" data-id="element-420">
                <span className="text-gray-400 line-through text-sm" data-id="element-421">
                  $47 USD
                </span>
                <span className="text-[#dc4a3d] font-bold text-sm" data-id="element-422">
                  INCLUIDO
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bono 1 */}
        <div className="bg-white rounded-2xl shadow-md border border-[#e8a020]/30 overflow-hidden" data-id="element-423">
          <div className="bg-[#e8a020] px-4 py-2" data-id="element-424">
            <span className="text-white text-xs font-bold uppercase tracking-wider" data-id="element-425">
              🎁 Bono 1
            </span>
          </div>
          <div className="p-5 flex gap-4 items-start" data-id="element-426">
            <img src="https://cdn.magicpatterns.com/uploads/nmx3uEpLK2xnk3Wj2hwqxZ/Portada_bono_1.png" alt="El Contrato Familiar" className="w-36 md:w-44 rounded-lg shadow-md shrink-0 object-cover" data-id="element-427" />
            <div className="flex-1" data-id="element-428">
              <h3 className="font-bold text-[#1e3a5f] text-base mb-1" data-id="element-429">
                El Contrato Familiar
              </h3>
              <p className="text-[#2d3748] text-sm mb-2 leading-relaxed" data-id="element-430">
                El documento legal-emocional que tus hijos aceptarán y firmarán
                para respetar los límites sin pelear.
              </p>
              <div className="flex items-center gap-2" data-id="element-431">
                <span className="text-gray-400 line-through text-sm" data-id="element-432">
                  $15 USD
                </span>
                <span className="text-[#e8a020] font-bold text-sm" data-id="element-433">GRATIS</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bono 2 */}
        <div className="bg-white rounded-2xl shadow-md border border-[#e8a020]/30 overflow-hidden" data-id="element-434">
          <div className="bg-[#e8a020] px-4 py-2" data-id="element-435">
            <span className="text-white text-xs font-bold uppercase tracking-wider" data-id="element-436">
              🎁 Bono 2
            </span>
          </div>
          <div className="p-5 flex gap-4 items-start" data-id="element-437">
            <img src="https://cdn.magicpatterns.com/uploads/5Jt9KATD8J3p2BLUAT7XFk/Portada_bono_2.png" alt="50 Ideas Sin Wi-Fi" className="w-36 md:w-44 rounded-lg shadow-md shrink-0 object-cover" data-id="element-438" />
            <div className="flex-1" data-id="element-439">
              <h3 className="font-bold text-[#1e3a5f] text-base mb-1" data-id="element-440">
                Guía "50 Ideas Sin Wi-Fi"
              </h3>
              <p className="text-[#2d3748] text-sm mb-2 leading-relaxed" data-id="element-441">
                El antídoto perfecto al "estoy aburrido". Actividades reales
                para conectar de verdad.
              </p>
              <div className="flex items-center gap-2" data-id="element-442">
                <span className="text-gray-400 line-through text-sm" data-id="element-443">
                  $12 USD
                </span>
                <span className="text-[#e8a020] font-bold text-sm" data-id="element-444">GRATIS</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bono 3 */}
        <div className="bg-white rounded-2xl shadow-md border border-[#e8a020]/30 overflow-hidden" data-id="element-445">
          <div className="bg-[#e8a020] px-4 py-2" data-id="element-446">
            <span className="text-white text-xs font-bold uppercase tracking-wider" data-id="element-447">
              🎁 Bono 3
            </span>
          </div>
          <div className="p-5 flex gap-4 items-start" data-id="element-448">
            <img src="https://cdn.magicpatterns.com/uploads/8YeZkRBniuEH88wPk7j2oY/Portada_bono_3.png" alt="Checklist Sueño Reparador" className="w-36 md:w-44 rounded-lg shadow-md shrink-0 object-cover" data-id="element-449" />
            <div className="flex-1" data-id="element-450">
              <h3 className="font-bold text-[#1e3a5f] text-base mb-1" data-id="element-451">
                Checklist "Sueño Reparador"
              </h3>
              <p className="text-[#2d3748] text-sm mb-2 leading-relaxed" data-id="element-452">
                El protocolo nocturno para que el cerebro de tu hijo descanse y
                se despierte de mejor humor.
              </p>
              <div className="flex items-center gap-2" data-id="element-453">
                <span className="text-gray-400 line-through text-sm" data-id="element-454">
                  $9 USD
                </span>
                <span className="text-[#e8a020] font-bold text-sm" data-id="element-455">GRATIS</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bridge block */}
      <div className="text-center max-w-md mx-auto mb-8" data-id="element-456">
        <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mb-4" data-id="element-457">
          Esto es lo que realmente estás llevando a tu casa:
        </h3>
        <div className="space-y-2.5 text-left max-w-sm mx-auto" data-id="element-458">
          <div className="flex items-center gap-3" data-id="element-459">
            <span className="text-[#6c5ce7] text-lg" data-id="element-460">✔️</span>
            <span className="text-[#2d3748] text-sm font-medium" data-id="element-461">
              Una estrategia clara
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-462">
            <span className="text-[#6c5ce7] text-lg" data-id="element-463">✔️</span>
            <span className="text-[#2d3748] text-sm font-medium" data-id="element-464">
              Un sistema familiar aplicable hoy
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-465">
            <span className="text-[#6c5ce7] text-lg" data-id="element-466">✔️</span>
            <span className="text-[#2d3748] text-sm font-medium" data-id="element-467">
              Una solución emocional inmediata
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-468">
            <span className="text-[#6c5ce7] text-lg" data-id="element-469">✔️</span>
            <span className="text-[#2d3748] text-sm font-medium" data-id="element-470">
              Herramientas prácticas listas para usar
            </span>
          </div>
        </div>
      </div>

      {/* Total value */}
      <div className="bg-[#1e3a5f] text-white p-5 rounded-xl text-center mb-5" data-id="element-471">
        <p className="text-blue-200 text-sm mb-1" data-id="element-472">Valor total del pack:</p>
        <p className="text-2xl font-bold line-through text-blue-300 mb-1" data-id="element-473">
          $83.00 USD
        </p>
        <p className="text-blue-100 text-sm" data-id="element-474">Hoy lo llevas por solo:</p>
        <p className="text-4xl font-extrabold text-[#e8a020]" data-id="element-475">$14.99 USD</p>
      </div>

      <Button fullWidth size="lg" onClick={handleScrollToPricing} className="shadow-xl shadow-red-200" data-id="element-476">
        SÍ, QUIERO ASEGURAR ESTA OFERTA HOY
      </Button>
      <p className="text-center text-xs text-gray-500 mt-2" data-id="element-477">
        Un solo pago • Acceso inmediato desde cualquier país
      </p>
    </Section>;
}